<template>
	<div class="rb-watch-party" :class="{ active: isActive }" @mousedown.stop @click.stop @dblclick.stop>
		<div class="activation-icon">
			<rb-player-button
				v-b-tooltip.hover.left
				title="Ver com amigos"
				@click.native="start"

				v-if="!sync"
				key="start"
			>
				<rb-icon>user-plus</rb-icon>
			</rb-player-button>

			<a :href="partyLink" @click.prevent.stop="copyLink" v-if="partyLink">
				<rb-player-button
					v-b-tooltip.hover.left
					title="Copiar link"
				>
					<rb-icon>link</rb-icon>
				</rb-player-button>
			</a>
		</div>

		<div class="drawer">
			<rb-collapse :collapsed="!progressMessage">
				<div class="connecting" v-b-tooltip.hover.left :title="progressMessage">
					<rb-loader class="connection-loader" inline />
				</div>
			</rb-collapse>

			<div class="peer-list" v-if="sync">
				<div
					v-for="peer in sync.peers"
					class="peer"
				>
					<div class="avatar"
						 v-b-tooltip.hover.left
						 :title="peer.user.Name"
					>
						<img :src="peer.user.AvatarUrl" alt="">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {VideoPlayer} from '../../VideoPlayer';
	import {User} from '../../../../../../shared/entities/User';
	import {VideoSyncService} from '../../VideoSyncService';
	import RbLoader from '../../../RbLoader';
	import RbCollapse from '../../../RbCollapse';
	import RbPlayerButton from '../RbPlayerButton';

	export default {
		name: 'RbWatchParty',
		components: { RbPlayerButton, RbCollapse, RbLoader },
		data: () => ({
			/** @type {VideoSyncService} **/
			sync: null,
			state: VideoSyncService.State,

			open: false
		}),
		props: {
			video: {
				type: VideoPlayer,
				required: true
			},
			user: {
				type: User,
				required: true
			}
		},
		watch: {
			$route() {
				if (this.sync) {
					this.sync.routeChange();
				}
			}
		},

		mounted() {
			if (this.$route.hash.length > 1) {
				this.start();

				this.sync.connect(this.$route.hash.substring(1));
			}
		},

		beforeDestroy() {
			this.sync.destroy();
		},

		methods: {
			start() {
				this.sync = new VideoSyncService(this.video, this.user, this.$router);

				window.syncInstance = this.sync;
			},

			copyLink() {
				if (navigator && navigator.clipboard) {
					navigator.clipboard.writeText(window.location.origin + this.partyLink);
				}

				return false;
			}
		},
		computed: {
			partyLink() {
				if (!this.sync || !this.sync.peer || !this.sync.peer.id) return '';

				return this.$route.fullPath.replace(this.$route.hash, '')+`#${this.sync.peer.id}`;
			},

			progressMessage() {
				if (!this.sync) return '';

				switch (this.sync.state) {
					case VideoSyncService.State.Preparing:
						return 'Inciando...';
					case VideoSyncService.State.Connecting:
						return 'Conectando...';
				}

				return '';
			},

			isActive() {
				return this.progressMessage || (this.sync && this.sync.peers.length);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.rb-watch-party {
		position: absolute;
		right: 0;
		left: 0;
		top: 0;
		bottom: 0;
		pointer-events: none;

		> * {
			pointer-events: all;
		}

		.activation-icon {
			position: absolute;
			right: 10px;
			top: 10px;
			transition: all .5s cubic-bezier(.43,-0.04,.25,1.01);

			display: flex;
			flex-direction: column;
		}


		$drawer-width: 2em;

		.drawer {
			position: absolute;
			right: -$drawer-width;
			top: 0;
			bottom: 0;

			width: $drawer-width;

			background: linear-gradient(to left, rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0));

			transition: all .5s cubic-bezier(.43,-0.04,.25,1.01);

			padding: 1.2em .5em 1em 0;


			.connecting {
				.rb-loader {
					margin-right: 5px;
				}
			}
		}

		&.active {
			.drawer, .activation-icon {
				transform: translateX(-$drawer-width);
			}
		}


		/*background: linear-gradient(to bottom, rgba(0, 0, 0, .4) 0%, rgba(0, 0, 0, .2) 100%);*/

		.peer-list {
			.peer {
				display: flex;

				.avatar {
					$size: 1.1em;

					flex-shrink: 0;
					width: $size;
					height: $size;

					border-radius: 50%;
					overflow: hidden;

					position: relative;

					transform: translateY($size * .25);

					margin-right: 15px;

					box-shadow: 0 0 5px rgba($success, 1);

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;

						position: absolute;
						left: 0;
						right: 0;
						top: 0;
						bottom: 0;
					}
				}
			}
		}
	}
</style>
